<div class="relative text-platform flex justify-center">
  <div class="page-container">
    <div class="h-32 lg:h-40"></div>
    <div class="font-bold text-4xl lg:text-5xl mb-10">Kontakt</div>
    <div class="grid lg:grid-cols-3 lg:place-content-center font-light">
      <div class="lg:mx-auto my-2">
        <div class="font-semibold text-2xl mb-4">Fachschaft Elektrotechnik</div>
        <div class="leading-snug mb-1">Augustinerbach 2a, 3.OG</div>
        <div class="leading-snug mb-1">52062 Aachen</div>
        <div class="leading-snug mb-1">Tel. 0241 80 97574</div>
        <div class="leading-snug mb-1">Email: fset&#64;rwth-aachen.de</div>
        <a
          class="leading-snug mb-1"
          href="https://fset.rwth-aachen.de"
          target="_blank"
          >fset.rwth-aachen.de</a
        >
      </div>
      <div class="lg:mx-auto my-2">
        <div class="font-semibold text-2xl mb-4">Fachschaft Maschinenbau</div>
        <div class="leading-snug mb-1">Eilschornsteinstraße 18</div>
        <div class="leading-snug mb-1">52062 Aachen</div>
        <div class="leading-snug mb-1">Tel. 0241 80 95308</div>
        <div class="leading-snug mb-1">Email: sport&#64;fsmb.rwth-aachen.de</div>
        <a
          class="leading-snug mb-1"
          href="https://fsmb.rwth-aachen.de"
          target="_blank"
          >fsmb.rwth-aachen.de</a
        >
      </div>
      <div class="lg:mx-auto my-2">
        <div class="font-semibold text-2xl mb-4">Fachschaft Medizin</div>
        <div class="leading-snug mb-1">Pauwelsstraße 30</div>
        <div class="leading-snug mb-1">52074 Aachen</div>
        <div class="leading-snug mb-1">Tel. 0241 80 88694</div>
        <div class="leading-snug mb-1">Email: unicup.fsmed&#64;rwth-aachen.de</div>
        <a
          class="leading-snug mb-1"
          href="https://fsmed-aachen.de"
          target="_blank"
          >fsmed-aachen.de</a
        >
      </div>
      <div class="mb-10"></div>
    </div>
  </div>
</div>
